export class QFilterGeneric {
  name = "generic"
  class_name = "QFilterGeneric" // Use class name here
  api_name = "generic_filter";
  chip_component = 'ChipGeneric';
  
  constructor(value) {
    this._value = value;
    /*if (! this.validate()) {
      throw `Invalid value in QFilter ${this.name}: ${value}`;
    }*/
  }
  
  get value() {
    return this._value;
  }

  get name() {
    return this.name;
  }
  
  validate() {
    //return true;
    return (this.value || (this.value != null));
  }

  chip_object() {
    return {
      value: this.value,
      name: this.name,
      readable: null, // The title name will show in the chip, with null the chip will use what he has
      component: this.chip_component
    };
  }
  
  serialize(qfilters) {
    return this.value;
  }
  
  as_query(qfilters) {
    // Returns {key: serialized_value} 
    if (this.api_name) {
    return {[this.api_name]: this.serialize(qfilters)};
    } else {
      return {};
    }
  }
}
